var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 15.5H0.5V0.5H15.5V15.5ZM7.99941 3.625C7.51664 3.625 7.125 4.00681 7.125 4.47936C7.125 8.96091 7.99941 9.68269 7.99941 9.68269C7.99941 9.68269 8.875 8.96091 8.875 4.47936C8.875 4.00681 8.48276 3.625 7.99941 3.625ZM7.99941 10.625C7.51664 10.625 7.125 11.0168 7.125 11.5003C7.125 11.9832 7.51663 12.375 7.99941 12.375C8.48276 12.375 8.875 11.9832 8.875 11.5003C8.875 11.0168 8.48276 10.625 7.99941 10.625Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Warning.a2c8ea671da4ed54fdac04534b7958e7.svg";